import { ChangeDetectorRef, Component, ElementRef, HostListener, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { ImmigrationService } from 'src/app/immigration/services/immigration.service';
import { AuthService } from '../../core/auth.service';
import { nullSafe } from '../../utils';
import { NgbDropdown } from '@ng-bootstrap/ng-bootstrap';

@Component({
	selector: 'eos-landing-page',
	templateUrl: './landing-page.component.html',
	styleUrls: ['./landing-page.component.css']
})
export class LandingPageComponent implements OnInit {
	expandedItem: string | null = null;
	isDropdownClose: boolean = false;
	@ViewChild('dropdown', { static: false, read: ElementRef }) dropdownElementRef: ElementRef;
	@ViewChild('dropdown') dropdown: NgbDropdown;

	constructor(
		private authService: AuthService,
		private immService: ImmigrationService
	) { }

	ngOnInit() {
		this.immService.country.next(null);
	}

	get isAdmin(): boolean {
		return this.authService.checkUserRole("ADM");
	}

	get isTemplateEditor(): boolean {
		return this.authService.hasClaim("template-editor");
	}

	get isImmTemplateEditor(): boolean {
		return this.authService.hasClaim("imm-template-editor");
	}

	get isImmActivityEditor(): boolean {
		return this.authService.hasClaim("imm-activity-editor");
	}

	get isExitActivityEditor(): boolean {
		return this.authService.hasClaim("exit-activity-editor");
  }

  get isImmDocumentVisamapping(): boolean {
    return this.authService.hasClaim("imm-document-visamapping");
  }

	get loggedInUserDisplayName(): string {

		return nullSafe(() => this.authService.ActiveUser.displayName, this.authService.AdUserName);
	}


	get showUser(): boolean {
		return this.authService.isAuthSuccessfull;
	}

	get isAmendTask(): boolean {
		return this.authService.hasClaim("amend-tasks");
	}

	get isExitTemplateEditor(): boolean {
		return this.authService.hasClaim("exit-template-editor");
	}
	get isConfigDropdownPJC(): boolean {
		return this.authService.hasClaim("config-pjc-dropdowns");
	}

	get isConfigDropdownIMM(): boolean {
		return this.authService.hasClaim("config-imm-dropdowns");
	}
	
	get isConfigDropdownEXT(): boolean {
		return this.authService.hasClaim("config-exit-dropdowns");
	}	
	isActiveModule(mid: string): boolean {
		return this.authService.isActiveFeature(mid);
	}

	logout() {
		this.authService.logout();
		// this.router.navigateByUrl('/logout');
	}
	selectOption(option: string, event: MouseEvent): void {
		event.preventDefault();
		event.stopPropagation();
		  this.expandedItem = this.expandedItem === option ? null : option;
		  if (this.dropdown && !this.dropdown.isOpen()) {
		  this.dropdown.open();
		}
	  }
	
	  closeDropdown(): void {
		this.expandedItem = null;
		  if (this.dropdown && this.dropdown.isOpen()) {
		  this.dropdown.close();
		}
	  }
	  @HostListener('document:click', ['$event'])
	  onDocumentClick(event: MouseEvent): void {
		if (!this.dropdownElementRef) {
		  return;
		}
		const isInsideDropdown = this.isClickInsideDropdown(event);
		  if (this.dropdown.isOpen() && !isInsideDropdown) {
		  this.closeDropdown();
		}
	  }
	  
	  private isClickInsideDropdown(event: MouseEvent): boolean {
		const dropdownElement = this.dropdownElementRef.nativeElement;
		return dropdownElement.contains(event.target);
	  }
	}
